<template>
  <div style="padding: 20px" class="content-container">
    <div>
      <button disabled class="btn primary small loading-btn">
        <span class="load"></span>
        <span>Loading</span>
      </button>
    </div>

    <!-- VUE TEL INPUT -->
    <tel-input v-model="phoneNumber" @country-changed="onCountryChanged" />

    <!-- CURRENCY INPUT -->
    <h2>Test new CURRENCY INPUT</h2>
    <VxCurrencyInput v-model="currencyInputValue" />

    <button @click="currencyInputValue = 1000">
      Set currency value to 1000
    </button>

    <!-- Select -->
    <h2>Select</h2>
    <div class="flex gap-20">
      <div style="width: 300px">
        <span>Single Select</span>

        <el-select
          v-model="selectValue"
          placeholder="Vui lòng chọn"
          @change="selectChange(selectValue)"
        >
          <el-option
            v-for="item in options5"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div style="width: 300px">
        <span>Multi Select</span>
        <el-select
          v-model="selectValueArray"
          multiple
          collapse-tags
          placeholder="Vui lòng chọn"
          @change="selectChange(selectValueArray)"
        >
          <el-option
            v-for="item in options5"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div style="width: 300px">
        <span>Select Filter</span>
        <el-select
          v-model="selectValueArray2"
          multiple
          collapse-tags
          filterable
          placeholder="Vui lòng chọn"
          @change="selectChange(selectValueArray2)"
        >
          <el-option
            v-for="item in options5"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <h2>Search Component</h2>
    <!-- <div class="content-container"> -->
    <search-comp @onSearch="onSearch" @onReset="onReset">
      <h3>Your Data here</h3>
    </search-comp>
    <br />
    <h2>Form Read-only</h2>
    <div>
      <section>
        <div class="das-info-title">Thông tin khách</div>
        <InfoList
          :columns="3"
          :column-breakpoint-options="{
            sm: 1,
            md: 3
          }"
        >
          <InfoListLabel style="max-width: 300px">Lorem ipsum</InfoListLabel>

          <InfoListValue style="max-width: 300px"
            >Lorem ipsum dolor sit amet consectetur adipisicing elit.
            Exercitationem eligendi magni expedita, deleniti reiciendis nihil
            corrupti molestiae ad iusto eaque?</InfoListValue
          >

          <InfoListLabel>Lorem ipsum</InfoListLabel>
          <InfoListValue>Lorem ipsum dolor sit amet. </InfoListValue>

          <InfoListLabel>Lorem ipsum</InfoListLabel>
          <InfoListValue>Lorem ipsum dolor sit amet.</InfoListValue>

          <InfoListLabel>Lorem ipsum</InfoListLabel>
          <InfoListValue>Lorem ipsum dolor sit amet.</InfoListValue>

          <InfoListLabel>Lorem ipsum</InfoListLabel>
          <InfoListValue>Lorem ipsum dolor sit amet.</InfoListValue>
        </InfoList>
      </section>
    </div>
    <!-- <div class="input-form-in-table">
      <table>
        <tr>
          <td>Tên khách</td>
          <td>Ngô Bá Khá</td>
          <td>Ngày đến</td>
          <td>20/11/2023</td>
          <td>Số dư</td>
          <td>100,000,000</td>
        </tr>
        <tr>
          <td>Phòng</td>
          <td>401</td>
          <td>Ngày đi</td>
          <td>2023/12/12</td>
          <td style="max-width: 250px">
            Tên cty, đại lý du lịchTên cty, đại lý du lịchTên cty, đại lý du
            lịchTên cty, đại lý du lịchTên cty, đại lý du lịch
          </td>
          <td>
            <div style="max-width: 250px">
              Tên cty, đại lý du lịchTên cty, đại lý du lịchTên cty, đại lý du
              lịchTên cty, đại lý du lịchTên cty, đại lý du lịchTên cty, đại lý
              du lịch
            </div>
          </td>
        </tr>
      </table>
      <div class="title-in-table">Thông tin khách</div>
      <table>
        <tr>
          <td>Tên khách</td>
          <td>Ngô Bá Khá</td>
          <td>Ngày đến</td>
          <td>20/11/2023</td>
          <td>Số dư</td>
          <td>100,000,000</td>
        </tr>
        <tr>
          <td>Phòng</td>
          <td>401</td>
          <td>Ngày đi</td>
          <td>2023/12/12</td>
          <td>Tên cty, đại lý du lịch</td>
          <td>
            <div style="max-width: 250px">
              Tên cty, đại lý du lịchTên cty, đại lý du lịchTên cty, đại lý du
              lịchTên cty, đại lý du lịchTên cty, đại lý du lịchTên cty, đại lý
              du lịch
            </div>
          </td>
        </tr>
      </table>
    </div> -->
    <br /><br />
    <!-- <Multiselect
      v-model="value"
      :options="optionsDatnt"
      :multiple="true"
      :close-on-select="false"
      :clear-on-select="false"
      :preserve-search="true"
      placeholder="Chọn đê"
      label="label"
      track-by="id"
      :preselect-first="true"
    >
      <template slot="selection" slot-scope="{ values, search, isOpen }">
        <span>
          <span
            v-if="values.length"
            v-show="!isOpen"
            class="multiselect__single"
            >{{ values.length }}options selected</span
          >
        </span>
      </template>
    </Multiselect>
    <pre class="language-json"><code>{{ value }}</code></pre> -->

    <CalendarRange
      v-model="datetimeRange"
      style="display: block; width: 500px"
      mode="date"
    />
    <button @click="onSubmit1">Submit</button>
    <button @click="datetimeRange = null">Reset Date</button>
    <p>{{ datetimeRange }}</p>

    <CalendarSelect
      v-model="datetime"
      style="display: block; width: 200px"
      mode="date"
      :min-max="{ min: '2023-12-12', max: '2024-1-15' }"
    />
    <button @click="onSubmit">Submit</button>
    <button @click="datetime = null">Reset Date</button>
    <p>{{ datetime }}</p>

    <h1>Das Button</h1>
    <h2>Primary Color</h2>
    <div style="display: flex; gap: 20px; align-items: flex-end">
      <das-button
        color="primary"
        prepare-icon="delete"
        append-icon="delete"
        size="medium"
        >Click me</das-button
      >
      <das-button
        color="primary"
        type="border"
        prepare-icon="delete"
        append-icon="delete"
        size="medium"
        >Click me</das-button
      >
      <das-button
        color="primary"
        prepare-icon="delete"
        append-icon="delete"
        size="small"
        >Click me</das-button
      >
    </div>
    <h2>Secondary Color</h2>
    <div style="display: flex; gap: 20px; align-items: flex-end">
      <das-button type="secondary" append-icon="delete" size="medium"
        >Warning</das-button
      >
      <das-button type="secondary" append-icon="delete" size="small"
        >Warning</das-button
      >
    </div>
    <h2>Only Icon</h2>
    <div style="display: flex; gap: 20px; align-items: flex-end">
      <das-button color="primary" size="medium" append-icon="delete" />
      <das-button color="primary" size="small" append-icon="delete" />
    </div>
    <h2>Text Button</h2>
    <div style="display: flex; gap: 20px; align-items: flex-end">
      <das-button color="primary" append-icon="delete" type="text" size="small"
        >Text button</das-button
      >
    </div>
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <!-- --------------------- -->
    <!-- --------------------- -->
    <!-- --------------------- -->
    <!-- --------------------- -->
    <!-- --------------------- -->
    <!-- --------------------- -->
    <!-- --------------------- -->
    <h2>Currency Input</h2>
    <div style="width: 300px">
      <currencyInput v-model="price" />
    </div>
    <h2>Test Tree Table With Checkbox</h2>
    <div class="grid-scroll" style="border: 1px solid red; height: 500px">
      <GridEnterprise
        ref="agGrid"
        :columns="columnDefs"
        dom-layout="scroll"
        :rows="rowData"
        class="agGrid"
        :group-grid="true"
        :tree-data="true"
        :default-col-def="defaultColDef"
        :group-use-entire-row="false"
        :auto-group-column-def="autoGroupColumnDef"
        :get-data-path="getDataPath"
        :enable-range-selection="true"
        :allow-context-menu-with-control-key="true"
        :get-context-menu-items="demoGetContextMenuItems"
        :suppress-context-menu="false"
      />
    </div>
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <button @click="checkTime">Time check</button>
    <div style="width: 500px">
      <VueTimepicker v-model="yourTimeValue" format="HH:mm:ss" />
    </div>
    <h2>Single Calendar</h2>
    <button @click="time1 = '2022-12-12'">Set Calendar to Null</button>
    <SingleCalendar v-model="time1" class="use-icon" />
    <h2>Tree select</h2>
    <div style="width: 400px">
      <treeselect
        v-model="valueTree"
        :multiple="false"
        :close-on-select="true"
        :disabled="false"
        :options="optionsTree"
        :searchable="true"
        placeholder="Tìm kiếm..."
        @search-change="searchChange"
      />
    </div>
    <div>
      <button @click="test">test change</button>
      <button @click="testRefresh">test refresh</button>
      <h2>Table theme 1</h2>
      <div
        class="grid-scroll mt-10"
        style="padding: 10px; background: white; height: 300px"
      >
        <GridVx
          ref="agGrid"
          :columns="columns"
          :rows="rows"
          dom-layout="scroll"
          class="agGrid"
          @rowClicked="toggleSidePanel"
        />
      </div>
      <!-- <h2>Table theme 2</h2>
      <div class="grid-scroll mt-10 sub-grid-theme" style="padding: 10px; background: white;">
        <GridVx
          ref="agGrid"
          :columns="columns"
          :rows="rows"
          class="agGrid"
          @rowClicked="toggleSidePanel"
        />
      </div> -->
    </div>
    <right-panel :width="33">
      <template>
        <!-- slot content -->
        <div class="content-container">
          <div class="content-header">
            <div class="content-header-left">
              <div class="icon-box">
                <div class="icon" />
              </div>
              <div class="info">
                <div class="title">#688</div>
                <div class="sub-title">Travelloka</div>
              </div>
            </div>
            <div class="content-header-right">
              <button
                class="btn primary medium outline"
                @click="closeSidePanel"
              >
                Hủy thay đổi
              </button>
              <button class="btn only-icon remove" @click="removeRow" />
            </div>
          </div>
          <div class="content-content">
            <div class="group">
              <h2>Hello world</h2>
              <h2>Hello world</h2>
              <h2>Hello world</h2>
            </div>
          </div>
        </div>
        <!-- end slot content -->
      </template>
    </right-panel>
    <!-- <right-panel :width="33">
      <template>
        <h1>HIHIHIHI</h1>
      </template>
    </right-panel> -->
    <button class="btn primary medium" @click="testAlert">Test alert</button>
    <button class="btn primary medium" @click="testConfirm">
      Test confirm
    </button>
    <button class="btn primary medium refresh" @click="toggleSidePanel">
      Toggle Side Panel
    </button>
    <button class="btn primary medium outline">Lưu</button>
    <button class="btn primary medium outline download">Xuất Excel</button>
    <button class="btn pink medium">Lưu</button>
    <button class="btn pink medium outline">Lưu</button>
    <button class="btn light-green medium">Lưu</button>
    <button class="btn amber medium">Lưu</button>
    <button class="btn amber medium outline">Lưu</button>
    <div>
      <button class="btn primary small">Lưu</button>
      <button class="btn primary small outline">Lưu</button>
      <button class="btn pink small">Lưu</button>
      <button class="btn pink small outline">Lưu</button>
      <button class="btn light-green small">Lưu</button>
      <button class="btn amber small">Lưu</button>
      <button class="btn amber small outline">Lưu</button>
    </div>
    <div style="width: 400px">
      <vue-tel-input
        v-model="phone"
        :input-options="options"
        @input="onInputTelNum"
        @country-changed="countryChange"
      />
    </div>
    <div>
      <button class="btn only-icon filter" />
      <button class="btn only-icon refresh" />
      <button class="btn only-icon remove" />
      <button class="btn text-icon edit">Chỉnh sửa</button>
    </div>
    <div style="margin-left: 10px">
      <el-switch
        v-model="value2"
        active-color="#357456"
        inactive-color="#CAC9C9"
      />
    </div>
    <!-- Search Form -->
    <h2>Search Form</h2>
    <div class="das-form-container">
      <div class="das-form-group">
        <div class="das-form-row">
          <div class="das-form-col w-20">
            <div class="das-form-input">
              <div class="label required">Ca</div>
              <input type="text" />
            </div>
          </div>
          <div class="das-form-col w-20">
            <div class="das-form-input">
              <div class="label required">Phòng</div>
              <input type="text" />
            </div>
          </div>
          <div class="das-form-col w-20">
            <div class="das-form-input">
              <div class="label required">Cánh</div>
              <input type="text" />
            </div>
          </div>
          <div class="das-form-col w-20">
            <div class="das-form-input">
              <div class="label required">Trạng thái</div>
              <input type="text" />
            </div>
          </div>
          <div class="das-form-col w-20">
            <div class="das-form-input">
              <div class="label required">Trạng thái đặt phòng</div>
              <input type="text" />
            </div>
          </div>
        </div>
        <div class="das-form-row">
          <div class="das-form-col w-20">
            <div class="das-form-input">
              <div class="label required">Hạng</div>
              <input type="text" />
            </div>
          </div>
          <div class="das-form-col w-20">
            <div class="das-form-input">
              <div class="label required">Tầng</div>
              <input type="text" />
            </div>
          </div>
          <div class="das-form-col w-20">
            <div class="das-form-input">
              <div class="label required">Tòa nhà</div>
              <!-- <input type="text"> -->
              <el-select
                v-model="value11"
                multiple
                collapse-tags
                placeholder="Select"
              >
                <el-option
                  v-for="item in options1"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
          </div>
          <div class="das-form-col w-20">
            <div class="das-form-input">
              <div class="label required">Sai lệch</div>
              <input type="text" />
            </div>
          </div>
          <div class="das-form-col w-20">
            <div class="das-form-input">
              <div class="label required">Tình hình phân công</div>
              <input type="text" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <br />
    <div class="das-layout">
      <div class="l-w-60 column">
        <div class="das-form-container">
          <div class="das-form-title-container">
            <div class="das-form-title">
              <span class="main-title">thông tin khách hàng</span>
              <span class="sub-title">(Theo từng khách sạn)</span>
            </div>
          </div>
          <hr />
          <div class="das-form-group">
            <!-- group -->
            <div class="das-form-group-title">Thông tin khách hàng</div>
            <!-- Row -->
            <div class="das-form-row">
              <!-- col -->
              <div class="das-form-col w-50">
                <div class="das-form-input">
                  <div class="label required">Đặt nhiều</div>
                  <div>
                    <div class="checkbox-wrap">
                      <input id="cpSpdTp3" type="checkbox" />
                      <label for="cpSpdTp3">Không in giá</label>
                    </div>
                    <div class="checkbox-wrap ml-10">
                      <input id="cpSpdTp4" type="checkbox" />
                      <label for="cpSpdTp4">Không hóa đơn</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="das-form-col w-50">
                <div class="das-form-input">
                  <div class="label required">Tên</div>
                  <!-- <input type="text" placeholder="Tên khách hàng"> -->
                  <select placeholder="Chọn">
                    <option value="1">Volvo</option>
                    <option value="2">BMW</option>
                    <option value="3">Porsche</option>
                  </select>
                </div>
              </div>
            </div>
            <!-- Row -->
            <div class="das-form-row">
              <!-- col -->
              <div class="das-form-col w-33">
                <div class="das-form-input">
                  <div class="label">Họ</div>
                  <!-- <input type="text" placeholder="Họ khách hàng"> -->
                  <div>
                    <div class="checks-wrap">
                      <input id="cpSpdTp1" type="radio" value="1" />
                      <label for="cpSpdTp1">Nguyễn</label>
                    </div>
                    <div class="checks-wrap ml-10">
                      <input id="cpSpdTp2" type="radio" value="1" />
                      <label for="cpSpdTp2">Trần</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="das-form-col w-33">
                <div class="das-form-input">
                  <div class="label required">Tên</div>
                  <input type="text" placeholder="Tên khách hàng" />
                </div>
              </div>
              <div class="das-form-col w-33">
                <div class="das-form-input">
                  <div class="label required">Tên</div>
                  <input type="text" placeholder="Tên khách hàng" />
                </div>
              </div>
            </div>
            <!-- Row -->
            <div class="das-form-row">
              <div class="das-form-col w-66">
                <div class="das-form-row">
                  <div class="das-form-col w-50">
                    <div class="das-form-input">
                      <div class="label required">Họ</div>
                      <input type="text" placeholder="Họ khách hàng" />
                    </div>
                  </div>
                  <div class="das-form-col w-50">
                    <div class="das-form-input">
                      <div class="label">Tên</div>
                      <input type="text" placeholder="Tên khách hàng" />
                    </div>
                  </div>
                </div>
                <div class="das-form-row">
                  <div class="das-form-col w-50">
                    <div class="das-form-input">
                      <div class="label required">Số điện thoại</div>
                      <!-- <input type="text" placeholder="Họ khách hàng"> -->
                      <div class="w-100">
                        <vue-tel-input
                          v-model="phone"
                          :input-options="options"
                          @input="onInputTelNum"
                          @country-changed="countryChange"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="das-form-col w-50">
                    <div class="das-form-input">
                      <div class="label">Tên</div>
                      <input type="text" placeholder="Tên khách hàng" />
                    </div>
                  </div>
                </div>
                <div class="das-form-row">
                  <div class="das-form-col w-50">
                    <div class="das-form-input">
                      <div class="label">Họ</div>
                      <input type="text" placeholder="Họ khách hàng" />
                    </div>
                  </div>
                  <div class="das-form-col w-50">
                    <div class="das-form-input">
                      <div class="label required">Tên</div>
                      <input type="text" placeholder="Tên khách hàng" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="das-form-col w-33">
                <!-- Hello world -->
                <div class="das-form-avatar-container">
                  <div>
                    <img />
                  </div>
                  <input id="input-1" type="file" style="display: none" />
                  <label class="upload-title" for="input-1">Cập nhật ảnh</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="das-form-container">
          <div class="das-form-title-container">
            <div class="das-form-title">
              <span class="main-title">thông tin khách hàng</span>
              <span class="sub-title">(Theo từng khách sạn)</span>
            </div>
          </div>
          <hr />
          <div class="das-form-group">
            <!-- group -->
            <div class="das-form-group-title">Thông tin khách hàng</div>
            <!-- Row -->
            <div class="das-form-row">
              <!-- col -->
              <div class="das-form-col w-50">
                <div class="das-form-input">
                  <div class="label">Họ</div>
                  <input type="text" placeholder="Họ khách hàng" />
                </div>
              </div>
              <div class="das-form-col w-50">
                <div class="das-form-input">
                  <div class="label">Tên</div>
                  <input type="text" placeholder="Tên khách hàng" />
                </div>
              </div>
            </div>
            <!-- Row -->
            <div class="das-form-row">
              <!-- col -->
              <div class="das-form-col w-33">
                <div class="das-form-input">
                  <div class="label">Họ</div>
                  <input type="text" placeholder="Họ khách hàng" />
                </div>
              </div>
              <div class="das-form-col w-33">
                <div class="das-form-input">
                  <div class="label">Tên</div>
                  <input type="text" placeholder="Tên khách hàng" />
                </div>
              </div>
              <div class="das-form-col w-33">
                <div class="das-form-input">
                  <div class="label">Tên</div>
                  <input type="text" placeholder="Tên khách hàng" />
                </div>
              </div>
            </div>
            <!-- Row -->
            <div class="das-form-row">
              <div class="das-form-col w-66">
                <div class="das-form-row">
                  <div class="das-form-col w-50">
                    <div class="das-form-input">
                      <div class="label">Họ</div>
                      <input type="text" placeholder="Họ khách hàng" />
                    </div>
                  </div>
                  <div class="das-form-col w-50">
                    <div class="das-form-input">
                      <div class="label">Tên</div>
                      <input type="text" placeholder="Tên khách hàng" />
                    </div>
                  </div>
                </div>
                <div class="das-form-row">
                  <div class="das-form-col w-50">
                    <div class="das-form-input">
                      <div class="label">Họ</div>
                      <input type="text" placeholder="Họ khách hàng" />
                    </div>
                  </div>
                  <div class="das-form-col w-50">
                    <div class="das-form-input">
                      <div class="label">Tên</div>
                      <input type="text" placeholder="Tên khách hàng" />
                    </div>
                  </div>
                </div>
                <div class="das-form-row">
                  <div class="das-form-col w-50">
                    <div class="das-form-input">
                      <div class="label">Họ</div>
                      <input type="text" placeholder="Họ khách hàng" />
                    </div>
                  </div>
                  <div class="das-form-col w-50">
                    <div class="das-form-input">
                      <div class="label">Tên</div>
                      <input type="text" placeholder="Tên khách hàng" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="das-form-col w-33">
                <!-- Hello world -->
                <div class="das-form-avatar-container">
                  <img />
                  <div class="upload-title">Cập nhật ảnh</div>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col">
                <div class="das-form-input">
                  <div class="label">Ghi chú</div>
                  <textarea style="width: 100%" :rows="4" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- </div> -->
      <div class="das-form-container l-w-30" style="width: 300px">
        <div class="das-form-title-container">
          <div class="das-form-title">
            <span class="main-title">người đại diện</span>
          </div>
          <button class="btn primary small outline">Thêm</button>
        </div>
        <!-- group 1 -->
        <div class="das-form-group">
          <div class="das-form-group-title">Người đại diện 1</div>
          <div class="das-form-row">
            <div class="das-form-col">
              <div class="das-form-input">
                <div class="label">Tên người đại diện</div>
                <input type="text" placeholder="Họ khách hàng" />
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col">
              <div class="das-form-input">
                <div class="label">Email</div>
                <input type="text" placeholder="Họ khách hàng" />
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col">
              <div class="das-form-input">
                <div class="label">Số điện thoại 1</div>
                <input type="text" placeholder="Họ khách hàng" />
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col">
              <div class="das-form-input">
                <div class="label">Số điện thoại 2</div>
                <input type="text" placeholder="Họ khách hàng" />
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col">
              <div class="das-form-input">
                <div class="label">Ngày sinh</div>
                <input type="text" placeholder="Họ khách hàng" />
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col">
              <div class="das-form-input">
                <div class="label">Thẻ căn cước</div>
                <input type="text" placeholder="Họ khách hàng" />
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col">
              <div class="das-form-input">
                <div class="label">Ngày cấp</div>
                <input type="text" placeholder="Họ khách hàng" />
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col">
              <div class="das-form-input">
                <div class="label">Nơi cấp</div>
                <input type="text" placeholder="Họ khách hàng" />
              </div>
            </div>
          </div>
        </div>
        <hr />
        <!-- group 2 -->
        <div class="das-form-group">
          <div class="das-form-group-title">Người đại diện 2</div>
          <div class="das-form-row">
            <div class="das-form-col">
              <div class="das-form-input">
                <div class="label">Tên người đại diện</div>
                <input type="text" placeholder="Họ khách hàng" />
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col">
              <div class="das-form-input">
                <div class="label">Email</div>
                <input type="text" placeholder="Họ khách hàng" />
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col">
              <div class="das-form-input">
                <div class="label">Số điện thoại 1</div>
                <input type="text" placeholder="Họ khách hàng" />
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col">
              <div class="das-form-input">
                <div class="label">Số điện thoại 2</div>
                <input type="text" placeholder="Họ khách hàng" />
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col">
              <div class="das-form-input">
                <div class="label">Ngày sinh</div>
                <input type="text" placeholder="Họ khách hàng" />
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col">
              <div class="das-form-input">
                <div class="label">Thẻ căn cước</div>
                <input type="text" placeholder="Họ khách hàng" />
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col">
              <div class="das-form-input">
                <div class="label">Ngày cấp</div>
                <input type="text" placeholder="Họ khách hàng" />
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col">
              <div class="das-form-input">
                <div class="label">Nơi cấp</div>
                <input type="text" placeholder="Họ khách hàng" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <h2>Select With Tree Search</h2>
    <SelectWithTreeView @valueChanged="changeValue" />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <table>
      <tr>
        <th>Company</th>
        <th>Contact</th>
        <th>Country</th>
      </tr>
      <tr v-for="(item, index) in tableData" :key="index">
        <td>{{ item.company }}</td>
        <td @click="onClicked1(index)">
          <span v-if="item.selected != 'contact'">{{ item.contact }}</span>
          <span v-else style="background: red">{{ item.contact }}</span>
        </td>
        <td @click="onClicked2(index)">
          <!-- <span>{{ item.country }}</span> -->
          <span v-if="item.selected != 'country'">{{ item.country }}</span>
          <span v-else style="background: red">{{ item.country }}</span>
        </td>
      </tr>
    </table>

    <h2>Tables Merge Data</h2>
    <TablesMergeData />
    <h2>Select With Table Search</h2>
    <SelectWithSearchTest />
    <div class="das-form-row" />
  </div>
</template>

<script>
import InfoListLabel from '@/components/info-list/InfoListLabel.vue'
import InfoListValue from '@/components/info-list/InfoListValue.vue'
// import { VueMaskDirective } from 'v-mask'
// import VueTheMask from 'vue-the-mask'
// Vue.use(VueTheMask)
// eslint-disable-next-line no-unused-vars
// import createNumberMask from 'text-mask-addons/dist/createNumberMask'
// const currencyMask = createNumberMask({
//   prefix: '$',
//   allowDecimal: true,
//   includeThousandsSeparator: true,
//   allowNegative: false
// })
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
import RightPanel from '@/components/RightPanel'
import TablesMergeData from '@/components/grid/TablesMergeData.vue'
import InfoList from '@/components/info-list/InfoList'
import SelectWithSearchTest from '@/components/inputs/SelectWithSearchTest.vue'
import SelectWithTreeView from '@/components/selectWithTreeView'
import DasButton from '@/components/ui/DasButton.vue'
import SingleCalendar from '@/components/ui/SingleCalendar.vue'
import CurrencyInput from '@/components/ui/currencyInput.vue'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
// import Multiselect from 'vue-multiselect'
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'
// import * as dayjs from 'dayjs'
export default {
  components: {
    SelectWithTreeView,
    RightPanel,
    Treeselect,
    InfoList,
    SingleCalendar,
    TablesMergeData,
    SelectWithSearchTest,
    VueTimepicker,
    CurrencyInput,
    DasButton,
    CalendarRange,
    CalendarSelect,
    InfoListLabel,
    InfoListValue
  },
  data() {
    return {
      currencyInputValue: null,
      selectValue: '1',
      selectValueArray: ['2', '3'],
      selectValueArray2: ['4', '5'],
      options5: [
        {
          value: '1',
          label: 'Option1'
        },
        {
          value: '2',
          label: 'Option2'
        },
        {
          value: '3',
          label: 'Option3'
        },
        {
          value: '4',
          label: 'Option4'
        },
        {
          value: '5',
          label: 'Option5'
        }
      ],
      value: [],
      optionsDatnt: [
        {
          label: 'Definite',
          id: 'isDefinite'
        },
        {
          label: 'Tentative',
          id: 'isTentative'
        },
        {
          label: 'Waiting',
          id: 'isWaiting'
        }
      ],
      datetime: '2023-12-12',
      datetimeRange: { start: '2023-12-12', end: '2023-12-15' },
      price: null,
      // currencyMask,
      myInputModel: '',
      agentItem: {
        name: '',
        email: '',
        note: '',
        profile_code: '',
        invoice_agent_name: '',
        profile_type: 0,
        phone_1: '',
        phone_2: '',
        address_1: '',
        address_2: '',
        business_code: '',
        tax_code: '',
        bank_number: '',
        bank_name: '',
        nation_id: 0,
        state_name: '',
        city_name: '',
        zip_code: '',
        representative_name: '',
        representative_email: '',
        representative_number_phone_1: '',
        representative_number_phone_2: '',
        representative_birthday: '',
        representative_id_card: '',
        representative_card_date: '',
        representative_card_place: '',
        market_seg_id: 0,
        business_person_id: null,
        source_id: 0,
        business_seg_id: 0,
        other_infor: false,
        debt_account_id: 0,
        contact_list: [
          {
            name: '',
            position: '',
            email: '',
            note: '',
            phone_number_1: '',
            phone_number_2: ''
          }
        ]
      },
      defaultColDef: [],
      autoGroupColumnDef: null,
      getDataPath: null,
      columnDefs: [],
      rowData: [],
      yourTimeValue: '20:21:00',
      time1: new Date(),
      // define the default value
      valueTree: null,
      options1: [
        {
          value: 'Option1',
          label: 'Option1'
        },
        {
          value: 'Option2',
          label: 'Option2'
        },
        {
          value: 'Option3',
          label: 'Option3'
        },
        {
          value: 'Option4',
          label: 'Option4'
        },
        {
          value: 'Option5',
          label: 'Option5'
        }
      ],
      value11: [],
      value21: [],
      // define options
      optionsTree: [
        {
          id: 'a',
          label: 'a',
          children: [
            {
              id: 'aa',
              label: 'aa',
              children: [
                {
                  id: 'aa',
                  label: 'aa'
                },
                {
                  id: 'ab',
                  label: 'ab'
                }
              ]
            },
            {
              id: 'ab',
              label: 'ab'
            }
          ]
        },
        {
          id: 'b',
          label: 'b'
        },
        {
          id: 'c',
          label: 'c'
        }
      ],
      columns: [
        {
          headerName: '',
          field: 'index',
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
        },
        {
          headerName:
            'Morbi accumsan ultricies orci, et efficitur magna malesuada sit amet',
          field: 'code',
          width: 100,
          wrapText: true,
          resizable: true,
          autoHeight: true,
          headerComponentParams: {
            template:
              '<div class="ag-cell-label-container" role="presentation">' +
              '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
              '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
              '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
              '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
              '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
              '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
              '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
              '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
              '  </div>' +
              '</div>'
          }
        },
        {
          headerName: 'Mô tả',
          field: 'desc'
        },
        {
          headerName: 'Thứ tự',
          field: 'order'
        }
      ],
      rows: [
        {
          code: 'abc',
          desc: 'Hello world',
          order: 1
        },
        {
          code: 'abc',
          desc: 'Hello world',
          order: 2
        },
        {
          code: 'abc',
          desc: 'Hello world',
          order: 3
        },
        {
          code: 'abc',
          desc: 'Hello world',
          order: 4
        },
        {
          code: 'abc',
          desc: 'Hello world',
          order: 5
        },
        {
          code: 'abc',
          desc: 'Hello world',
          order: 6
        },
        {
          code: 'abc',
          desc: 'Hello world',
          order: 5
        },
        {
          code: 'abc',
          desc: 'Hello world',
          order: 6
        },
        {
          code: 'abc',
          desc: 'Hello world',
          order: 5
        },
        {
          code: 'abc',
          desc: 'Hello world',
          order: 6
        },
        {
          code: 'abc',
          desc: 'Hello world',
          order: 5
        },
        {
          code: 'abc',
          desc: 'Hello world',
          order: 6
        },
        {
          code: 'abc',
          desc: 'Hello world',
          order: 5
        },
        {
          code: 'abc',
          desc: 'Hello world',
          order: 6
        },
        {
          code: 'abc',
          desc: 'Hello world',
          order: 5
        },
        {
          code: 'abc',
          desc: 'Hello world',
          order: 6
        },
        {
          code: 'abc',
          desc: 'Hello world',
          order: 7
        },
        {
          code: 'abc',
          desc: 'Hello world',
          order: 8
        },
        {
          code: 'abc',
          desc: 'Hello world',
          order: 9
        },
        {
          code: 'abc',
          desc: 'Hello world',
          order: 10
        }
      ],
      phone: '+213837087040',
      options: {
        placeholder: 'abc'
      },
      value2: true,
      tableData: [
        {
          company: 'Maria Anders',
          contact: 'Maria Anders',
          country: 'Germany',
          selected: 'contact'
        },
        {
          company: 'Maria Anders',
          contact: 'Maria Anders',
          country: 'Germany',
          selected: 'contact'
        }
      ]
    }
  },
  watch: {
    currencyInputValue(value) {
      console.log('emit', value)
    },
    price(value) {
      console.log('price', value)
    },
    time1() {
      console.log('On Change Date: ', this.time1)
    },
    valueTree(value) {
      console.log('Watch Tree: ', value)
    }
  },
  beforeMount() {
    this.defaultColDef = { flex: 1 }
    this.columnDefs = [
      // we're using the auto group column by default!
      {
        field: 'groupType',
        valueGetter: function (params) {
          return params.data ? 'Provided' : 'Filler'
        }
      }
    ]
    this.autoGroupColumnDef = {
      headerName: 'Organisation Hierarchy',
      // headerCheckboxSelection: true,
      cellRendererParams: {
        checkbox: true,
        // innerRenderer: true,
        // minWidth: 300,
        suppressCount: true
        // suppressCount: true,
        // checkbox: (params) => {
        //   return params.node.level === 0
        // },
        // innerRenderer: (params) => {
        //   return params.data.package_code
        // }
      }
    }
    this.rowData = [
      { orgHierarchy: ['A'] },
      { orgHierarchy: ['A', 'B'] },
      { orgHierarchy: ['C', 'D'] },
      { orgHierarchy: ['E', 'F', 'G', 'H'] }
    ]
    this.getDataPath = data => {
      return data.orgHierarchy
    }
  },
  mounted() {},
  methods: {
    onCountryChanged(countryObj) {
      console.log(countryObj)
    },
    selectChange(sel) {
      console.log('selected', sel)
    },
    onSearch() {},
    onReset() {},
    demoGetContextMenuItems(params) {
      var result = [
        {
          // custom item
          name: 'Alert ' + params.value,
          action: () => {
            window.alert('Alerting about ' + params.value)
          },
          cssClasses: ['red', 'bold']
        },
        {
          // custom item
          name: 'Always Disabled',
          disabled: true,
          tooltip:
            'Very long tooltip, did I mention that I am very long, well I am! Long!  Very Long!'
        },
        {
          name: 'Country',
          subMenu: [
            {
              name: 'Ireland',
              action: () => {
                console.log('Ireland was pressed')
              }
              // icon: createFlagImg('ie')
            },
            {
              name: 'UK',
              action: () => {
                console.log('UK was pressed')
              }
              // icon: createFlagImg('gb')
            },
            {
              name: 'France',
              action: () => {
                console.log('France was pressed')
              }
              // icon: createFlagImg('fr')
            }
          ]
        },
        {
          name: 'Person',
          subMenu: [
            {
              name: 'Niall',
              action: () => {
                console.log('Niall was pressed')
              }
            },
            {
              name: 'Sean',
              action: () => {
                console.log('Sean was pressed')
              }
            },
            {
              name: 'John',
              action: () => {
                console.log('John was pressed')
              }
            },
            {
              name: 'Alberto',
              action: () => {
                console.log('Alberto was pressed')
              }
            },
            {
              name: 'Tony',
              action: () => {
                console.log('Tony was pressed')
              }
            },
            {
              name: 'Andrew',
              action: () => {
                console.log('Andrew was pressed')
              }
            },
            {
              name: 'Kev',
              action: () => {
                console.log('Kev was pressed')
              }
            },
            {
              name: 'Will',
              action: () => {
                console.log('Will was pressed')
              }
            },
            {
              name: 'Armaan',
              action: () => {
                console.log('Armaan was pressed')
              }
            }
          ]
        }, // built in separator
        'separator',
        {
          // custom item
          name: 'Windows',
          shortcut: 'Alt + W',
          action: () => {
            console.log('Windows Item Selected')
          },
          icon: '<img src="https://www.ag-grid.com/example-assets/skills/windows.png" />'
        },
        {
          // custom item
          name: 'Mac',
          shortcut: 'Alt + M',
          action: () => {
            console.log('Mac Item Selected')
          },
          icon: '<img src="https://www.ag-grid.com/example-assets/skills/mac.png"/>'
        }, // built in separator
        'separator',
        {
          // custom item
          name: 'Checked',
          checked: true,
          action: () => {
            console.log('Checked Selected')
          },
          icon: '<img src="https://www.ag-grid.com/example-assets/skills/mac.png"/>'
        }, // built in copy item
        'copy',
        'separator',
        'chartRange'
      ]

      return result
    },
    // add contact in add pro5
    addContact() {
      this.agentItem.contact_list.push({
        name: '',
        position: '',
        email: '',
        note: '',
        phone_number_1: '',
        phone_number_2: ''
      })
      // this.agentItem.contact_list = []
    },
    checkTime() {
      console.log('checkTime', this.yourTimeValue)
    },
    test() {
      this.rows[5].order = this.rows[5].order + 1
    },
    testRefresh() {
      this.rows = JSON.parse(JSON.stringify(this.rows))
      // this.rows.push({})
    },
    onChangeDate(date) {
      this.time1 = date
    },
    searchChange(val) {
      setTimeout(() => {
        if (document.querySelector('.vue-treeselect__no-results-tip-text')) {
          document.querySelector(
            '.vue-treeselect__no-results-tip-text'
          ).innerHTML = 'Không có dữ liệu đâu bạn ơi :v'
        }
      }, 50)
    },
    toggleSidePanel() {
      // console.log('toggleSidePanel')
      this.$store.dispatch('settings/changeShowRightPanel', true)
    },
    closeSidePanel() {
      this.$store.dispatch('settings/changeShowRightPanel', false)
    },
    removeRow() {
      this.$vxConfirm('Bạn chắc chắn muốn xóa?', () => {
        this.closeSidePanel()
      })
    },
    testConfirm() {
      this.$vxConfirm('Bạn muốn thực thi hành động này?', () => {
        alert('ok con de')
      })
    },
    testAlert() {
      this.$vxAlert('“아이디”를 입력해 주세요.')
    },
    onInputTelNum(param) {
      console.log('onInputTelNum', param, this.phone)
    },
    countryChange(param) {
      console.log('country change: ', param.dialCode)
      this.phone = param.dialCode
    },

    changeValue(data) {
      console.log('Change valueeeeeee: ', data)
    },
    onClicked1(data) {
      this.tableData[data].selected = 'contact'
      console.log(this.tableData[data].selected)
    },
    onClicked2(data) {
      this.tableData[data].selected = 'country'
    },

    onSubmit() {
      console.log(this.datetime)
    },
    onSubmit1() {
      console.log(this.datetimeRange)
    }
  }
}
</script>

<style lang="scss">
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

tr:nth-child(even) {
  background-color: #dddddd;
}
</style>
